// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dOWH","label":"styles_label__1BSl7"};